export default "__VITE_ASSET__DYNIwqVh__"